import { DEFAULT_REVIEW_START_TIME } from "@performyard/utils-isomorphic";

export default {
	pageName: "createReviewCycle",

	blipHeight: 40,
	formWidth: 572,
	formHorizontalMargin: 40,
	formVerticalMargin: 40,
	formBorderSize: 1,
	formControlsHeight: 60,
	maxFormsCount: 100,

	inputs: [
		{
			key: "cyclename",
			_type: "text",
			label: "Review Cycle Name",
			isRequired: true,
			isClearable: false,
			placeholder: "Review Cycle Name",
		},
		{
			key: "adminedit",
			_type: "checkbox",
			label: "Lock Reviews from Non-Admins",
			info: {
				message:
					"Selecting this box will only allow admins to make process changes such as adding forms, changing authors/signers, modifying visibility and updating due dates for these reviews.",
			},
			isRequired: false,
			isClearable: false,
		},
		{
			key: "grouppicker",
			_type: "picker",
			label: "Group-Specific Cycle (Optional)",
			info: {
				message:
					"Selecting a group will limit potential review subjects to only employees in the group. This will also provide access to the cycle for Group Administrators, if any.",
			},
			type: "department",
			isRequired: false,
			placeholder: "Select a group",
			showIsOptional: false,
			isClearable: true,
		},
		{
			key: "template",
			_type: "picker",
			label: "Which review template would you like to use?",
			type: "templates",
			isRequired: true,
			isClearable: false,
			placeholder: "Select a template",
		},
		{
			key: "startdate",
			_type: "datepicker",
			label: "Review Cycle Start Date",
			props: { width: 400, hasTime: true, defaultTime: DEFAULT_REVIEW_START_TIME },
			isRequired: true,
			isClearable: false,
		},
	],
};
